// 官网提示说明（非表单）
export default {
  暂无内容: 'No content yet.',
  无内容: 'No content yet.',
  暂无相关的全球展览: 'No relevant exhibitions yet.',
  暂无相关的全球会议: 'No relevant conferences yet.',
  暂无相关的企业: 'No relevant companies yet.',
  暂无相关的展品: 'No relevant exhibits yet.',
  暂无相关的产业头条: 'No relevant industry news yet.',
  刷新页面: 'Refresh the page',
  返回首页: 'Back to home page',
  '抱歉,您无权访问此页面。': 'Sorry, you do not have permission to access this page.',
  '抱歉,您访问的页面不存在。': 'Sorry, the page you visit does not exist.',
  '服务器开小差啦，请再次刷新或检查网络': 'Server is down, please refresh or check the network.',
}
